import * as React from "react";
import classnames from "classnames";
import { Icon } from "@grandvisionhq/icons";
import { Skeleton } from "@grandvisionhq/iris-ui";
/* empty css                       */
import Text from "../../Typography/Text/Typography/Text/Text.js";
import Heading from "../../Typography/Heading/Typography/Heading/Heading.js";
const CodeScannerCamera = ({
  cameraError,
  cameraContainerRef,
  labels,
  className,
  status
}) => {
  return /* @__PURE__ */ React.createElement("div", { className: classnames("code-scanner", className) }, /* @__PURE__ */ React.createElement(
    "div",
    {
      ref: cameraContainerRef,
      className: `code-scanner__camera code-scanner__camera--${status}`
    }
  ), status !== "error" && status !== "scanning" && /* @__PURE__ */ React.createElement("div", { className: "code-scanner__loader" }, /* @__PURE__ */ React.createElement(
    Skeleton,
    {
      height: "100%",
      width: "100%",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      "aria-label": labels.loadingText
    },
    /* @__PURE__ */ React.createElement("rect", { width: "100%", height: "100%", rx: "5", fill: "currentColor" })
  )), status === "scanning" && /* @__PURE__ */ React.createElement("div", { className: "code-scanner__description" }, /* @__PURE__ */ React.createElement(Text, { className: "code-scanner__text", variant: "body-head" }, labels.title), /* @__PURE__ */ React.createElement("div", { className: "code-scanner__spacer" }), /* @__PURE__ */ React.createElement(Text, { className: "code-scanner__text" }, labels.description)), status === "error" && /* @__PURE__ */ React.createElement(
    ErrorScreen,
    {
      className: "code-scanner__error-screen",
      title: labels[`${cameraError}ErrorTitle`],
      description: labels[`${cameraError}ErrorDescription`]
    }
  ));
};
const ErrorScreen = ({ className, title, description }) => /* @__PURE__ */ React.createElement("div", { className }, /* @__PURE__ */ React.createElement(Icon, { className: `${className}__content`, name: "warning", height: 32, width: 32 }), /* @__PURE__ */ React.createElement(Heading, { className: `${className}__content`, variant: "subheading1", component: "h2" }, title), /* @__PURE__ */ React.createElement(Text, { className: `${className}__content` }, description));
export {
  CodeScannerCamera
};
//# sourceMappingURL=CodeScannerCamera.js.map
